var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "BaseModal",
    {
      attrs: {
        "is-open": _vm.isOpen,
        "is-loading": _vm.isStatusLoading,
        "content-wrapper-class": "contact-us-modal",
        identifier: "contact-us",
      },
      on: { "modal-close": _vm.closeModal },
    },
    [_c("div", { attrs: { id: "promiseCaptchaContainer" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }